import {
    apiRequest,
    seminarCreate
} from "../../../../../services/adapters/kepegawaian/seminarService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", seminarCreate, {
            body: query
        }, true)
    }

}

export default CreateRepository